import { UUID_PATTERN } from '@/constants/uuid.js'

const dash = [
  {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    meta: {
      auth: true,
    },
    component: () => import('@/view/Layouts/DashContainer/DashContainer.vue'),
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/view/pages/shared/Dashboard.vue'),
      },
      {
        path: '/profile',
        component: () => import('@/view/pages/shared/profile/Overview.vue'),
        children: [
          {
            path: '',
            redirect: '/profile/personal',
          },
          {
            path: 'personal',
            name: 'Perfil - Meus Dados',
            component: () => import('@/view/pages/shared/profile/Pages/Personal.vue'),
          },
          {
            path: 'services',
            name: 'Perfil - Planos e Serviços',
            component: () => import('@/components/cards/PlansServicesCard.vue'),
          },
          {
            path: 'allowed-users',
            name: 'Perfil - Usuários Permitidos',
            component: () => import('@/view/pages/shared/profile/Tables/AllowedUsersTable.vue'),
          },
        ],
      },
      {
        path: '/user',
        component: () => import('@/view/pages/shared/user/Overview.vue'),
        // Configurações da própria conta (avatar) — admin sem vínculo pode acessar.
        meta: {
          adminUnlinked: true,
        },
        children: [
          {
            path: '',
            name: 'Configurações de Usuário',
            redirect: '/user/configs',
          },
          {
            path: 'configs',
            name: 'Configurações',
            component: () => import('@/view/pages/shared/user/Security.vue'),
          },
          {
            path: 'limits',
            name: 'Limites de transações',
            component: () => import('@/view/pages/shared/user/Limits.vue'),
          },
        ],
      },
      {
        path: '/notifications',
        name: 'Notificações',
        component: () => import('@/view/pages/shared/notifications/Overview.vue'),
        // Sino do header — admin sem vínculo pode acessar.
        meta: {
          adminUnlinked: true,
        },
        children: [
          {
            path: '',
            name: 'Notificações - Notificações',
            redirect: '/notifications/list',
          },
          {
            path: 'list',
            name: 'Notificações - Lista',
            component: () =>
              import('@/view/pages/shared/notifications/tables/NotificationsTable.vue'),
          },
          {
            path: 'settings',
            name: 'Notificações - Configurações',
            component: () => import('@/view/pages/shared/notifications/pages/Settings.vue'),
          },
        ],
      },
      {
        path: '/contacts',
        name: 'Contatos',
        component: () => import('@/view/pages/shared/contacts/Overview.vue'),
      },
      {
        path: '/contacts/create',
        name: 'Cadastro de Clientes',
        component: () => import('@/view/pages/shared/contacts/Create.vue'),
      },
      {
        path: '/contacts/import',
        name: 'Upload de CSV',
        component: () => import('@/view/pages/shared/contacts/CreateContactsLot.vue'),
      },
      {
        path: '/contacts/details/:id',
        name: 'Detalhe do Contato',
        component: () => import('@/view/pages/shared/contacts/Details.vue'),
      },
      {
        path: '/authorize',
        name: 'Autorização de Operações',
        component: () => import('@/view/pages/shared/authorization/Overview.vue'),
      },
      {
        path: '/link',
        name: 'Vinculos',
        component: () => import('@/view/pages/shared/profile/Linking.vue'),
        // Botão "Contas" — escolher cliente para vincular. Admin sem vínculo pode acessar.
        meta: {
          adminUnlinked: true,
        },
      },
      {
        path: '/statement',
        name: 'Contas - Extratos',
        component: () => import('@/view/pages/shared/statement/Overview.vue'),
        children: [
          {
            path: '',
            name: 'Contas - Extrato Completo',
            redirect: '/statement/full',
          },
          {
            path: 'full',
            component: () => import('@/view/pages/shared/statement/Pages/FullStatement.vue'),
          },
          {
            path: 'summary',
            name: 'Contas - Extrato Resumido',
            component: () => import('@/view/pages/shared/statement/Pages/SummaryStatement.vue'),
          },
        ],
      },
      {
        path: '/boleto_deposito',
        name: 'Depósito - Boleto Depósitos',
        component: () => import('@/view/pages/shared/deposit/boleto/Deposit.vue'),
      },
      {
        path: '/pix_deposito/:id?',
        name: 'Depósitos ImoPIX',
        component: () => import('@/view/pages/shared/deposit/imopix/Overview.vue'),
      },
      {
        path: '/recognize',
        name: 'Contas - Reconhecimento - Reconhecimento de Depósitos',
        component: () => import('@/view/pages/shared/deposit/reconhecimento/Recognize.vue'),
      },
      {
        path: '/pix',
        component: () => import('@/view/pages/shared/pix/Overview.vue'),
        children: [
          {
            path: '',
            name: 'PIX',
            redirect: '/pix/transactions',
          },
          {
            path: 'transactions',
            name: 'Transações',
            component: () => import('@/view/pages/shared/pix/Pages/PixAreaTable.vue'),
          },
          {
            path: 'limits',
            name: 'Limites de Pix',
            component: () => import('@/view/pages/shared/pix/Pages/PixLimits.vue'),
          },
        ],
      },
      {
        path: '/transfers/:contactId?',
        name: 'Transferências',
        component: () => import('@/view/pages/shared/transfers/Transfers.vue'),
      },
      {
        path: '/ordens_pagamento',
        name: 'Ordens de Pagamentos',
        props: true,
        component: () => import('@/view/pages/shared/payment_orders/PaymentOrders.vue'),
        children: [
          {
            path: '',
            name: 'Ordens de Pagamento - Ordens',
            redirect: '/ordens_pagamento/orders',
          },
          {
            path: 'orders',
            name: 'Ordens de Pagamento - Lista',
            component: () =>
              import('@/view/pages/shared/payment_orders/Tables/PaymentOrderList.vue'),
          },
          {
            path: 'claims',
            name: 'Ordens de Pagamento - Meus Resgates',
            component: () =>
              import('@/view/pages/shared/payment_orders/Tables/ClaimedPaymentOrderList.vue'),
          },
        ],
      },
      {
        path: '/transfers/lote',
        name: 'Transferência em Lote',
        component: () => import('@/view/pages/shared/transfers/BatchTransfer.vue'),
      },
      {
        path: '/pagamentos',
        name: 'Pagamento de Contas',
        component: () => import('@/view/pages/shared/pagamentos/Overview.vue'),
      },
      {
        path: '/pagamentos/create/:code_line?',
        name: 'Cadastro de Pagamento de Conta',
        props: true,
        component: () => import('@/view/pages/shared/pagamentos/pages/Create.vue'),
      },
      {
        path: '/pagamentos/import_csv',
        name: 'Importação CSV de Contas',
        component: () => import('@/view/pages/shared/pagamentos/ImportCsv.vue'),
      },
      {
        path: '/investimentos',
        name: 'Investimentos',
        component: () => import('@/view/pages/shared/investments/debentures/Overview.vue'),
      },
      {
        path: '/investimentos/meus_investimentos',
        component: () => import('@/view/pages/shared/investments/debentures/MyDebentures.vue'),
        redirect: '/investimentos/meus_investimentos/lista',
        children: [
          {
            path: 'lista',
            name: 'Debentures - Minhas Debentures',
            component: () =>
              import('@/view/pages/shared/investments/debentures/Tables/MinhasDebentures.vue'),
          },
          {
            path: 'extrato',
            name: 'Debentures - Extrato de Debentures',
            component: () =>
              import('@/view/pages/shared/investments/debentures/Tables/ExtratoOpDebentures.vue'),
          },
          {
            path: 'intencoes',
            name: 'Debentures - Intenções de Investimento',
            component: () =>
              import(
                '@/view/pages/shared/investments/debentures/Tables/IntentionsPurchaseDebentures.vue'
              ),
          },
          {
            path: 'propostas',
            name: 'Debentures - Minhas Propostas',
            component: () => import('@/view/pages/shared/investments/debentures/MyProposals.vue'),
          },
        ],
      },
      {
        path: '/investimentos/meus_investimentos/debenture/:id',
        name: 'Debentures - Detalhes da debenture',
        component: () => import('@/view/pages/shared/investments/debentures/DetailsDebenture.vue'),
      },
      {
        path: '/antecipacao',
        name: 'Antecipação de Recebíveis',
        component: () => import('@/view/pages/shared/antecipacao/Overview.vue'),
        redirect: '/antecipacao/list',
        children: [
          // {
          //   path: 'geral',
          //   name: 'Antecipação de Recebíveis - Visão Geral',
          //   component: () => import('@/view/pages/shared/antecipacao/Pages/General.vue'),
          // },
          {
            path: 'list',
            name: 'Antecipação de Recebíveis - Lista',
            component: () => import('@/view/pages/shared/antecipacao/Pages/List.vue'),
          },
          {
            path: 'propostas',
            name: 'Antecipação de Recebíveis - Propostas',
            component: () => import('@/view/pages/shared/antecipacao/Pages/Proposals.vue'),
          },
          {
            path: 'solicitacoes',
            name: 'Antecipação de Recebíveis - Solicitações',
            component: () => import('@/view/pages/shared/antecipacao/Pages/Solicitations.vue'),
          },
        ],
      },
      {
        // :anticipation restrito a UUID — evita que /antecipacao/<texto> (ex.: "bloqueios")
        // case esta rota e dispare getDebtAdvancement com um id inválido (erro 500).
        path: `/antecipacao/:anticipation(${UUID_PATTERN})`,
        name: 'Detalhe de Antecipação',
        component: () => import('@/view/pages/shared/antecipacao/Pages/Detail.vue'),
      },
      {
        path: `/antecipacao/:anticipation(${UUID_PATTERN})/saldo_devedor`,
        name: 'Detalhe de Antecipação - Saldo Devedor',
        component: () => import('@/view/pages/shared/antecipacao/Pages/SaldoDevedor.vue'),
      },
      {
        path: `/antecipacao/:anticipation(${UUID_PATTERN})/status_titulos`,
        name: 'Detalhes de Títulos de Antecipacão',
        component: () =>
          import('@/view/pages/admin/antecipacao/tabs/AntecipacaoTituloStatusTab.vue'),
      },
      {
        path: `/antecipacao/proposta/:id(${UUID_PATTERN})`,
        name: 'Detalhe de Proposta',
        component: () => import('@/view/pages/shared/antecipacao/Pages/ProposalDetail.vue'),
      },
      {
        path: '/wallets/:new?',
        name: 'Carteiras',
        props: true,
        component: () => import('@/view/pages/shared/wallets/Overview.vue'),
      },
      {
        path: '/debts/single',
        name: 'Créditos - Títulos',
        component: () => import('@/view/pages/shared/debts/single/Overview.vue'),
      },
      {
        path: '/debts/single/:id',
        name: 'Créditos - Detalhes de Título',
        component: () => import('@/view/pages/shared/debts/single/Details.vue'),
      },
      {
        path: '/debts/composite',
        name: 'Créditos - Carnês',
        component: () => import('@/view/pages/shared/debts/composite/Overview.vue'),
      },
      {
        path: '/debts/composite/:id',
        name: 'Créditos - Carnês - Detalhes de Carnê',
        component: () => import('@/view/pages/shared/debts/composite/Details.vue'),
      },
      {
        path: '/debts/import',
        name: 'Créditos - Importação de Títulos',
        component: () => import('@/view/pages/shared/debts/DebtLotCreate.vue'),
      },
      {
        path: '/contracts/overview',
        name: 'Contratos',
        component: () => import('@/view/pages/shared/contracts/Overview.vue'),
      },
      {
        path: '/contracts/details/:id',
        name: 'Contratos - Detalhamento de Contrato',
        component: () => import('@/view/pages/shared/contracts/Details.vue'),
      },
      {
        path: '/reports',
        component: () => import('@/view/pages/shared/reports/Overview.vue'),
        children: [
          {
            path: '',
            name: 'Relatórios',
            redirect: '/reports/analytic',
          },
          {
            path: 'analytic',
            name: 'Relatório Analítico',
            component: () => import('@/view/pages/shared/reports/Analytic.vue'),
          },
          {
            path: 'synthetic',
            name: 'Relatório Sintético',
            component: () => import('@/view/pages/shared/reports/Synthetic.vue'),
          },
          {
            path: 'financial_income',
            name: 'Informe de Rendimentos',
            component: () => import('@/view/pages/shared/reports/IRPF.vue'),
          },
        ],
      },
      // {
      //   path: '/cambio',
      //   name: 'Cambio',
      //   component: () => import('@/view/pages/shared/cambio/Overview.vue'),
      // },
      {
        path: '/products',
        name: 'Produtos e Serviços',
        component: () => import('@/view/pages/shared/products/Overview.vue'),
      },
      {
        path: '/products/create',
        name: 'Criar Produtos e Serviços',
        component: () => import('@/view/pages/shared/products/Create.vue'),
      },
      {
        path: 'products/:id/edit',
        name: 'Editar Produtos Serviços',
        component: () => import('@/view/pages/shared/products/Create.vue'),
      },
      {
        path: '/vendas',
        name: 'Vendas',
        component: () => import('@/view/pages/shared/vendas/Overview.vue'),
      },
      {
        path: '/vendas/create',
        name: 'Nova Venda',
        component: () => import('@/view/pages/shared/vendas/Create.vue'),
      },
      {
        path: '/vendas/:id/edit',
        name: 'Editar Venda',
        component: () => import('@/view/pages/shared/vendas/Edit.vue'),
      },
      {
        path: '/indication',
        component: () => import('@/view/pages/shared/indication/Overview.vue'),
        children: [
          {
            path: '',
            name: 'Painel de Indicações',
            redirect: '/indication/commissions',
          },
          {
            path: 'commissions',
            name: 'Comissões',
            component: () => import('@/view/pages/shared/indication/Tabs/Commissions.vue'),
          },
          {
            path: 'plans',
            name: 'Planos',
            component: () => import('@/view/pages/shared/indication/Tabs/Plans.vue'),
          },
        ],
      },

      {
        path: '/tarifas/pendentes',
        name: 'Tarifas Pendentes',
        props: true,
        component: () => import('@/view/pages/shared/tarifas/pendentes/feePendingList.vue'),
      },
      {
        path: '/mfa-setup',
        name: 'MFA Setup',
        component: () => import('@/view/pages/shared/user/MfaSetup.vue'),
        // Configurações da própria conta (avatar) — admin sem vínculo pode acessar.
        meta: {
          adminUnlinked: true,
        },
      },
    ],
  },
]

export default dash
